import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import DesktopChangesView from '../../images/desktop-changesview.png';
import ScrollToAnchor from '~/src/components/scroll-to-anchor';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ScrollToAnchor mdxType="ScrollToAnchor" />
    <h2>{`Getting started`}</h2>
    <p>{`GitHub Desktop is a git workflow tool built on Electron. It's available on both macOS and Windows and was designed to feel like a native application, considering the core differences between the two platforms. It's meant to look platform agnostic and neutral, rather than mimicking the Primer styles used on github.com. These guidelines cover the basic principles and foundation elements to consider when designing for Desktop.`}</p>
    <img src={DesktopChangesView} alt="" />
    <h2>{`Principles`}</h2>
    <p>{`Follow these principles to help guide your design choices.`}</p>
    <h3>{`Promote good git behavior`}</h3>
    <p>{`Encourage using git sucessfully so that users can better communicate the work they've done to their teams and for their own records. For example, we encourage well written commit messages by making partial committing easy.`}</p>
    <h3>{`Balance the spectrum between “git” and “magic”`}</h3>
    <p>{`Consider what the UI explicitly shows the user and what is hidden behind controls and feels like "magic". It's important to achieve a good balance between these two paradigms, so that users can understand what is happening and troubleshoot when necessary.`}</p>
    <h3>{`Prioritize beginners over advanced developers`}</h3>
    <p>{`Always consider the needs of, and optimize for, beginner developers in favor of advanced developers.`}</p>
    <h3>{`Help developers learn as they go`}</h3>
    <p>{`Use git terminology and add clarifying information and hints throughout to help users understand just enough of what’s going on behind the scenes. When git language is used accurately, users can more easily troubleshoot and learn concepts quickly.`}</p>
    <h3>{`Put what’s next front and center`}</h3>
    <p>{`Always make it clear what the next step is after any given action. This helps beginner develolpers to learn common workflows.`}</p>
    <p>{`You can read more about how GitHub Desktop makes product decisions in the
`}<a parentName="p" {...{
        "href": "https://github.com/desktop/desktop/blob/development/docs/process/what-is-desktop.md"
      }}>{`"What is GitHub Desktop and who is it for?"`}</a>{` document.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      